import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const FlyoutMenuItem = (_param)=>{
    var { link , action , children , className , tealiumAttributes  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "link",
        "action",
        "children",
        "className",
        "tealiumAttributes"
    ]);
    return /*#__PURE__*/ React.createElement("li", swcHelpers.extends({
        className: classnames('flyout-menu-item', className)
    }, rest), !action && link && /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
        href: link,
        className: "flyout-menu-item__link"
    }, tealiumAttributes), children), action && /*#__PURE__*/ React.createElement("button", {
        onClick: action,
        className: "flyout-menu-item__link"
    }, children));
};

export { FlyoutMenuItem as default };
//# sourceMappingURL=FlyoutMenuItem.js.map
